// Generated by purs version 0.14.4
import * as Data_Coordinates from "../Data.Coordinates/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Accounts_Types_Id from "../Restaumatic.Accounts.Types.Id/index.js";
import * as Restaumatic_Addresses_Types from "../Restaumatic.Addresses.Types/index.js";
import * as Restaumatic_Restaurant_Types_Id from "../Restaumatic.Restaurant.Types.Id/index.js";
import * as Restaumatic_TypesGen from "../Restaumatic.TypesGen/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var ReverseGeocodeResponse = function (x) {
    return x;
};
var ReverseGeocodeRequest = function (x) {
    return x;
};
var GeocodeResponse = function (x) {
    return x;
};
var GeocodeRequest = function (x) {
    return x;
};
var eqReverseGeocodeResponse = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Addresses_Types.eqStreetAddress))(x.streetAddress)(y.streetAddress);
        };
    }
};
var eqReverseGeocodeRequest = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Coordinates.eqCoordinates)(x.coordinates)(y.coordinates);
        };
    }
};
var eqGeocodeResponse = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Maybe.eqMaybe(Data_Coordinates.eqCoordinates))(x.coordinates)(y.coordinates);
        };
    }
};
var eqGeocodeRequest = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Accounts_Types_Id.eqAccountId))(x.accountId)(y.accountId) && Data_Eq.eq(Restaumatic_TypesGen.eqCountry)(x.country)(y.country) && Data_Eq.eq(Data_Maybe.eqMaybe(Data_Eq.eqBoolean))(x.fromPS)(y.fromPS) && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Restaurant_Types_Id.eqRestaurantId))(x.restaurantId)(y.restaurantId) && Data_Eq.eq(Restaumatic_Addresses_Types.eqStreetAddress)(x.streetAddress)(y.streetAddress);
        };
    }
};
var rpcMethodNameReverseGeocodeRequest = {
    rpcMethodName: function (v) {
        return "ReverseGeocodeRequest";
    }
};
var rpcMethodNameGeocodeRequest = {
    rpcMethodName: function (v) {
        return "GeocodeRequest";
    }
};
var newtypeReverseGeocodeResponse = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeReverseGeocodeRequest = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeGeocodeResponse = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeGeocodeRequest = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldReverseGeocodeResponse = function (dictHasField) {
    return dictHasField;
};
var hasFieldReverseGeocodeRequest = function (dictHasField) {
    return dictHasField;
};
var hasFieldGeocodeResponse = function (dictHasField) {
    return dictHasField;
};
var hasFieldGeocodeRequest = function (dictHasField) {
    return dictHasField;
};
var genericReverseGeocodeResponse = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showReverseGeocodeResponse = {
    show: Data_Show_Generic.genericShow(genericReverseGeocodeResponse)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "streetAddress";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Maybe.showMaybe(Restaumatic_Addresses_Types.showStreetAddress)))))({
        reflectSymbol: function () {
            return "ReverseGeocodeResponse";
        }
    }))
};
var unscrambleDecodeReverseGeocodeResponse = {
    unsafeDecode: Unscramble_Generic.genericUnsafeDecode(genericReverseGeocodeResponse)(Unscramble_Generic.genericDecodeSingleConstructor(Unscramble_Generic.genericDecodeArgsSingleArg(Unscramble.decode_Record()(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "streetAddress";
        }
    })(Unscramble.decode_Maybe(Restaumatic_Addresses_Types.unscrambleDecodeStreetAddress))(Unscramble.decodeRecordNil)))))(Unscramble_Generic.defaultOptions)
};
var genericReverseGeocodeRequest = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showReverseGeocodeRequest = {
    show: Data_Show_Generic.genericShow(genericReverseGeocodeRequest)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "coordinates";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Coordinates.showCoordinates))))({
        reflectSymbol: function () {
            return "ReverseGeocodeRequest";
        }
    }))
};
var unscrambleDecodeReverseGeocodeRequest = {
    unsafeDecode: Unscramble_Generic.genericUnsafeDecode(genericReverseGeocodeRequest)(Unscramble_Generic.genericDecodeSingleConstructor(Unscramble_Generic.genericDecodeArgsSingleArg(Unscramble.decode_Record()(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "coordinates";
        }
    })(Data_Coordinates.unscrambleDecodeCoordinates)(Unscramble.decodeRecordNil)))))(Unscramble_Generic.defaultOptions)
};
var genericGeocodeResponse = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showGeocodeResponse = {
    show: Data_Show_Generic.genericShow(genericGeocodeResponse)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "coordinates";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Maybe.showMaybe(Data_Coordinates.showCoordinates)))))({
        reflectSymbol: function () {
            return "GeocodeResponse";
        }
    }))
};
var unscrambleDecodeGeocodeResponse = {
    unsafeDecode: Unscramble_Generic.genericUnsafeDecode(genericGeocodeResponse)(Unscramble_Generic.genericDecodeSingleConstructor(Unscramble_Generic.genericDecodeArgsSingleArg(Unscramble.decode_Record()(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "coordinates";
        }
    })(Unscramble.decode_Maybe(Data_Coordinates.unscrambleDecodeCoordinates))(Unscramble.decodeRecordNil)))))(Unscramble_Generic.defaultOptions)
};
var genericGeocodeRequest = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showGeocodeRequest = {
    show: Data_Show_Generic.genericShow(genericGeocodeRequest)(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "accountId";
        }
    })(Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "country";
        }
    })(Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "fromPS";
        }
    })(Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "streetAddress";
        }
    })(Data_Show.showRecordFieldsNil)(Restaumatic_Addresses_Types.showStreetAddress))(Data_Maybe.showMaybe(Restaumatic_Restaurant_Types_Id.showRestaurantId)))(Data_Maybe.showMaybe(Data_Show.showBoolean)))(Restaumatic_TypesGen.showCountry))(Data_Maybe.showMaybe(Restaumatic_Accounts_Types_Id.showAccountId)))))({
        reflectSymbol: function () {
            return "GeocodeRequest";
        }
    }))
};
var unscrambleDecodeGeocodeRequest = {
    unsafeDecode: Unscramble_Generic.genericUnsafeDecode(genericGeocodeRequest)(Unscramble_Generic.genericDecodeSingleConstructor(Unscramble_Generic.genericDecodeArgsSingleArg(Unscramble.decode_Record()(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "accountId";
        }
    })(Unscramble.decode_Maybe(Restaumatic_Accounts_Types_Id.udecodeAccountId))(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "country";
        }
    })(Restaumatic_TypesGen.unscrambleDecodeCountry)(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "fromPS";
        }
    })(Unscramble.decode_Maybe(Unscramble.decode_Boolean))(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(Unscramble.decode_Maybe(Restaumatic_Restaurant_Types_Id.udecodeRestaurantId))(Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "streetAddress";
        }
    })(Restaumatic_Addresses_Types.unscrambleDecodeStreetAddress)(Unscramble.decodeRecordNil)))))))))(Unscramble_Generic.defaultOptions)
};
var encodingOpts = {
    sumEncoding: Foreign_Generic_Class.defaultOptions.sumEncoding,
    unwrapSingleConstructors: true,
    unwrapSingleArguments: Foreign_Generic_Class.defaultOptions.unwrapSingleArguments,
    unwrapSingleRecordArguments: true,
    fieldTransform: Foreign_Generic_Class.defaultOptions.fieldTransform
};
var encodeReverseGeocodeResponse = {
    encode: Foreign_Generic.genericEncode(genericReverseGeocodeResponse)(Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ReverseGeocodeResponse";
        }
    })(Foreign_Generic_Class.genericEncodeArgsRecord(Foreign_Generic_Class.encodeWithOptionsRecord()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "streetAddress";
        }
    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(Restaumatic_Addresses_Types.encodeStreetAddress)))))))(encodingOpts)
};
var encodeReverseGeocodeRequest = {
    encode: Foreign_Generic.genericEncode(genericReverseGeocodeRequest)(Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ReverseGeocodeRequest";
        }
    })(Foreign_Generic_Class.genericEncodeArgsRecord(Foreign_Generic_Class.encodeWithOptionsRecord()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "coordinates";
        }
    })(Foreign_Generic_Class.encodeWithOptionsOther(Data_Coordinates.encodeCoordinates))))))(encodingOpts)
};
var encodeGeocodeResponse = {
    encode: Foreign_Generic.genericEncode(genericGeocodeResponse)(Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "GeocodeResponse";
        }
    })(Foreign_Generic_Class.genericEncodeArgsRecord(Foreign_Generic_Class.encodeWithOptionsRecord()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "coordinates";
        }
    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(Data_Coordinates.encodeCoordinates)))))))(encodingOpts)
};
var encodeGeocodeRequest = {
    encode: Foreign_Generic.genericEncode(genericGeocodeRequest)(Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "GeocodeRequest";
        }
    })(Foreign_Generic_Class.genericEncodeArgsRecord(Foreign_Generic_Class.encodeWithOptionsRecord()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "streetAddress";
        }
    })(Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Addresses_Types.encodeStreetAddress)))({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(Restaumatic_Restaurant_Types_Id.encodeRestaurantId))))({
        reflectSymbol: function () {
            return "fromPS";
        }
    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.booleanEncode))))({
        reflectSymbol: function () {
            return "country";
        }
    })(Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_TypesGen.encodeCountry)))({
        reflectSymbol: function () {
            return "accountId";
        }
    })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.maybeEncode(Restaumatic_Accounts_Types_Id.encodeAccountId)))))))(encodingOpts)
};
var decodeReverseGeocodeResponse = {
    decode: Foreign_Generic.genericDecode(genericReverseGeocodeResponse)(Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ReverseGeocodeResponse";
        }
    })(Foreign_Generic_Class.genericDecodeArgsRecord(Foreign_Generic_Class.decodeWithOptionsRecord()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "streetAddress";
        }
    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Restaumatic_Addresses_Types.decodeStreetAddress)))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
var decodeReverseGeocodeRequest = {
    decode: Foreign_Generic.genericDecode(genericReverseGeocodeRequest)(Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ReverseGeocodeRequest";
        }
    })(Foreign_Generic_Class.genericDecodeArgsRecord(Foreign_Generic_Class.decodeWithOptionsRecord()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "coordinates";
        }
    })(Foreign_Generic_Class.decodeWithOptionsOther(Data_Coordinates.decodeCoordinates))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
var decodeGeocodeResponse = {
    decode: Foreign_Generic.genericDecode(genericGeocodeResponse)(Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "GeocodeResponse";
        }
    })(Foreign_Generic_Class.genericDecodeArgsRecord(Foreign_Generic_Class.decodeWithOptionsRecord()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "coordinates";
        }
    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Data_Coordinates.decodeCoordinates)))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
var decodeGeocodeRequest = {
    decode: Foreign_Generic.genericDecode(genericGeocodeRequest)(Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "GeocodeRequest";
        }
    })(Foreign_Generic_Class.genericDecodeArgsRecord(Foreign_Generic_Class.decodeWithOptionsRecord()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "streetAddress";
        }
    })(Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Addresses_Types.decodeStreetAddress))())({
        reflectSymbol: function () {
            return "restaurantId";
        }
    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Restaumatic_Restaurant_Types_Id.decodeRestaurantId)))())({
        reflectSymbol: function () {
            return "fromPS";
        }
    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.booleanDecode)))())({
        reflectSymbol: function () {
            return "country";
        }
    })(Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_TypesGen.decodeCountry))())({
        reflectSymbol: function () {
            return "accountId";
        }
    })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Restaumatic_Accounts_Types_Id.decodeAccountId)))())))(Foreign_Generic_Class.genericCountArgsArgument))(encodingOpts)
};
export {
    GeocodeRequest,
    GeocodeResponse,
    ReverseGeocodeRequest,
    ReverseGeocodeResponse,
    encodingOpts,
    genericGeocodeRequest,
    showGeocodeRequest,
    eqGeocodeRequest,
    decodeGeocodeRequest,
    unscrambleDecodeGeocodeRequest,
    encodeGeocodeRequest,
    newtypeGeocodeRequest,
    hasFieldGeocodeRequest,
    rpcMethodNameGeocodeRequest,
    genericGeocodeResponse,
    showGeocodeResponse,
    eqGeocodeResponse,
    decodeGeocodeResponse,
    unscrambleDecodeGeocodeResponse,
    encodeGeocodeResponse,
    newtypeGeocodeResponse,
    hasFieldGeocodeResponse,
    genericReverseGeocodeRequest,
    showReverseGeocodeRequest,
    eqReverseGeocodeRequest,
    decodeReverseGeocodeRequest,
    unscrambleDecodeReverseGeocodeRequest,
    encodeReverseGeocodeRequest,
    newtypeReverseGeocodeRequest,
    hasFieldReverseGeocodeRequest,
    rpcMethodNameReverseGeocodeRequest,
    genericReverseGeocodeResponse,
    showReverseGeocodeResponse,
    eqReverseGeocodeResponse,
    decodeReverseGeocodeResponse,
    unscrambleDecodeReverseGeocodeResponse,
    encodeReverseGeocodeResponse,
    newtypeReverseGeocodeResponse,
    hasFieldReverseGeocodeResponse
};
//# sourceMappingURL=index.js.map
